import Vue from 'vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import LoadingContainer from '@/components/LoadingContainer.vue';

Vue.component(ErrorMessage.name, ErrorMessage);
Vue.component(LoadingContainer.name, LoadingContainer);